export default {
  DateOfBirthFormField__ARIA: "Date of birth",
  DateOfBirthFormField__CAPTION: "MM/DD/YYYY",
  DateOfBirthFormField__LABEL: "Date of birth",
  DateOfBirthFormField__LAP_CHILD_INVALID_DATE:
    "Lap children must be greater than 14 days old but less than 2 years old on date of flights.",
};
